import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Col,
  Row,
  message,
  Select,
  Radio,
  DatePicker,
  Button,
  Switch,
  Tag,
} from "antd";
import {
  API_METHODS,
  BLANK_VALUE,
  DEFAULT_DATE_FORMAT,
} from "../../../constants";
import useApi from "../../../hooks/useApi";
import {
  formatDate,
  formatDateToDayJS,
  getBanks,
  getClientConfig,
  getDebtors,
  getTrueOrFalseFromZeroAndOne,
  replaceBlankValueToUndefined,
} from "../../../generalFunctions";
import dayjs from "dayjs";
import { isEmpty } from "../../../generalFunctions";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";

const { TextArea } = Input;

function AddReleaseOrder(props) {
  const [form] = Form.useForm();
  const {
    visible,
    close,
    selectedRecord,
    isViewOnly,
    isViewModal,
    isClassified,
  } = props;
  const [response, request] = useApi("/releaseOrder", null, API_METHODS.POST);
  const [editResponse, editRequest] = useApi(
    `/releaseOrder/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT
  );
  const { account, caption, voucherType, publication } = getClientConfig();
  const [advancePaymentFields, setAdvancePaymentFields] = useState();
  const [isSingle, setIsSingle] = useState();
  const [multipleDates, setMultipleDates] = useState([]);
  const [creditorInfo, setCreditorInfo] = useState();
  const [balance, getBalance] = useApi(
    "/releaseOrder/balance",
    null,
    API_METHODS.GET
  );
  const [singleGetResponse, singleGetRequest] = useApi(
    `/releaseOrder/`,
    null,
    API_METHODS.GET
  );
  const [creditorBalance, SetCreditorBalance] = useState();
  const [loadingSaveButton, setLoadingSaveButton] = useState(false);

  useEffect(() => {
    if (response.data) {
      close(true);
      setLoadingSaveButton(false);
      message.success("Release Order added successfully.");
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      setLoadingSaveButton(false);
      message.success("Release Order updated successfully.");
    }
  }, [editResponse]);

  useEffect(() => {
    if (balance.data) {
      SetCreditorBalance(
        `Rs:${balance.data.balanceAmount}-${balance.data.type}`
      );
    }
  }, [balance]);

  useEffect(() => {
    if (selectedRecord) {
      let initialValues = { ...selectedRecord };
      initialValues = replaceBlankValueToUndefined(initialValues);
      initialValues.roDate = formatDateToDayJS(initialValues.roDate);
      initialValues.chequeDate = formatDateToDayJS(initialValues.chequeDate);
      advancePaymentSwitchChanged(
        getTrueOrFalseFromZeroAndOne(initialValues.advancePayment)
      );
      initialValues.isSingle = getTrueOrFalseFromZeroAndOne(
        initialValues.isSingle
      );
      initialValues.isBillDone = getTrueOrFalseFromZeroAndOne(
        initialValues.isBillDone
      );
      setIsSingle(initialValues.isSingle);
      if (initialValues.isSingle) {
        //Date of insertion
        initialValues.dateOfInsertion = formatDateToDayJS(
          initialValues.dateOfInsertion
        );
      } else {
        //Multiple Date of insertion
        let spiltDates = initialValues.dateOfInsertion.split(",");
        setMultipleDates(spiltDates);
        initialValues.dateOfInsertion = null;
      }
      showCreditor(initialValues.publicationId);
      form.setFieldsValue(initialValues);
    }
  }, [selectedRecord]);

  useEffect(() => {
    if (
      singleGetResponse &&
      !isEmpty(singleGetResponse.data) &&
      !singleGetResponse.isLoading
    ) {
      const { data } = singleGetResponse;
      let initialValues = data[0];
      initialValues = replaceBlankValueToUndefined(initialValues);
      initialValues.roDate = formatDateToDayJS(initialValues.roDate);
      initialValues.chequeDate = formatDateToDayJS(initialValues.chequeDate);
      advancePaymentSwitchChanged(
        getTrueOrFalseFromZeroAndOne(initialValues.advancePayment)
      );
      initialValues.isSingle = getTrueOrFalseFromZeroAndOne(
        initialValues.isSingle
      );
      initialValues.isBillDone = getTrueOrFalseFromZeroAndOne(
        initialValues.isBillDone
      );
      setIsSingle(initialValues.isSingle);
      if (initialValues.isSingle) {
        //Date of insertion
        initialValues.dateOfInsertion = formatDateToDayJS(
          initialValues.dateOfInsertion
        );
      } else {
        //Multiple Date of insertion
        let spiltDates = initialValues.dateOfInsertion.split(",");
        setMultipleDates(spiltDates);
        initialValues.dateOfInsertion = null;
      }
      showCreditor(initialValues.publicationId);
      form.setFieldsValue(initialValues);
      //  setSelectedRecord(data[0]);
    } else if (
      singleGetResponse &&
      singleGetResponse.data === BLANK_VALUE &&
      !singleGetResponse.isLoading
    ) {
      message.error("Realease Order not found");
    }
  }, [singleGetResponse]);

  const handleOk = () => {
    form.validateFields().then((values) => {
      if (!loadingSaveButton) {
        let amountForOneDay = 0;
        if (isClassified === 1) {
          amountForOneDay = values.rate;
        } else {
          amountForOneDay = values.width * values.height * values.rate;
        }
        values.isClassified = isClassified;
        if (!values.isSingle) {
          if (multipleDates.length < 2) {
            message.error("Please add multiple dates for bill mode -Multiple");
            return false;
          }
        }
        setLoadingSaveButton(true);
        if (selectedRecord) {
          values.roDate = formatDateToDayJS(values.roDate).tz("Asia/Kolkata");
          if (values.chequeDate) {
            values.chequeDate = formatDateToDayJS(values.chequeDate);
          }
          if (!values.isSingle) {
            values.roAmount = amountForOneDay * multipleDates.length;
            values.dateOfInsertion = multipleDates.toString();
            values.publicationBillRemaining = multipleDates.length;
          } else {
            values.roAmount = amountForOneDay;
            values.dateOfInsertion = formatDateToDayJS(
              values.dateOfInsertion
            ).tz("Asia/Kolkata");
            values.publicationBillRemaining = 1;
          }

          editRequest(values);
        } else {
          if (!values.isSingle) {
            values.roAmount = amountForOneDay * multipleDates.length;
            values.dateOfInsertion = multipleDates.toString();
            values.publicationBillRemaining = multipleDates.length;
          } else {
            values.roAmount = amountForOneDay;
            values.dateOfInsertion = formatDateToDayJS(values.dateOfInsertion);
            values.publicationBillRemaining = 1;
          }
          if (values.chequeDate) {
            values.chequeDate = formatDateToDayJS(values.chequeDate);
          }
          request(values, API_METHODS.POST);
        }
      }
    });
  };

  const handleCancel = () => {
    close();
  };

  const advancePaymentSwitchChanged = (checked) => {
    if (checked) {
      setAdvancePaymentFields([
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="paymentBy"
              label="Payment By"
              rules={[{ required: true, message: "Payment By is required." }]}
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {voucherType.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.type}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="bankId" label="Bank">
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {getBanks(account).map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.accountName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="chequeNumber" label="Cheque/D.D Number">
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="chequeDate" label="Cheque Date">
              <DatePicker format={DEFAULT_DATE_FORMAT} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="advanceAmount"
              label="Advance Amount"
              rules={[
                {
                  required: true,
                  message: "Advance Amount is required.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="nameOfPost"
              label="Name Of Post"
              rules={[
                {
                  max: 500,
                  message: "Name Of Post should be maximum of 500 characters.",
                },
              ]}
            >
              <TextArea showCount maxLength={500} />
            </Form.Item>
          </Col>
        </Row>,
      ]);
    } else {
      setAdvancePaymentFields([]);
    }
  };

  const radioChanged = (e) => {
    setIsSingle(e.target.value);
  };

  const showCreditor = (publicationId) => {
    const record = publication.find((record) => record.id === publicationId);
    let creditor = undefined;
    let creditorId = record.creditorId;
    if (isClassified === 1 && !isEmpty(record.classifiedCreditorId)) {
      creditorId = record.classifiedCreditorId;
    }
    creditor = account.find((a) => a.id === creditorId);

    setCreditorInfo(creditor);
    if (!isViewOnly) {
      getBalance(null, API_METHODS.GET, `/releaseOrder/balance/${creditorId}`);
    }
  };

  const previousButtonClicked = () => {
    let ro_id = form.getFieldValue("id") - 1;
    singleGetRequest(
      null,
      API_METHODS.GET,
      `/releaseOrder/${ro_id}?isClassified=${props.isClassified}`
    );
  };
  const nextButtonClicked = () => {
    let ro_id = form.getFieldValue("id") + 1;
    singleGetRequest(
      null,
      API_METHODS.GET,
      `/releaseOrder/${ro_id}?isClassified=${props.isClassified}`
    );
  };

  const addDateInTag = () => {
    const date = form.getFieldValue("dateOfInsertion");
    if (!isEmpty(date)) {
      const newDates = [...multipleDates];
      newDates.push(formatDate(date));
      setMultipleDates(newDates);
      form.setFieldValue("dateOfInsertion", null);
    }
  };

  const handleCloseTag = (removedDate) => {
    const newDates = multipleDates.filter((date) => date !== removedDate);
    setMultipleDates(newDates);
  };

  const getTag = (tag) => {
    const tagElem = (
      <Tag
        closable
        onClose={(e) => {
          e.preventDefault();
          handleCloseTag(tag);
        }}
      >
        {tag}
      </Tag>
    );
    return tagElem;
  };

  const formComp = (
    <Form
      layout="vertical"
      form={form}
      disabled={isViewOnly}
      initialValues={
        isClassified === 1
          ? {
              roDate: dayjs(),
              dateOfInsertion: dayjs().add(1, "day"),
              language: "English",
              specialInstruction:
                "Category - Change in Name (affidavit attached)",
              isSingle: true, // bill mode single
              captionId: 195,
            }
          : {
              roDate: dayjs(),
              dateOfInsertion: dayjs().add(1, "day"),
              isSingle: true, // bill mode single
            }
      }
    >
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="id" label="R.O. Number">
            <Input disabled={true} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="roDate"
            label="R.O.Date"
            rules={[{ required: true, message: "RO Date is required." }]}
          >
            <DatePicker format={DEFAULT_DATE_FORMAT} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="isSingle"
            label="Bill Mode"
            rules={[{ required: true, message: "Bill Mode is required." }]}
          >
            <Radio.Group onChange={radioChanged}>
              <Radio value={true}>Single</Radio>
              <Radio value={false}>Multiple</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="publicationId"
            label="Publication"
            rules={[{ required: true, message: "Publication is required." }]}
          >
            <Select
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onChange={showCreditor}
            >
              {publication.map((option) => (
                <Select.Option key={option.id} value={option.id}>
                  {option.publicationName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {isViewModal === true && (
          <Col span={8}>
            <Form.Item label="Creditor">{creditorInfo?.accountName}</Form.Item>
          </Col>
        )}

        {/* {!isViewOnly && (
          <Col span={8}>
            <Form.Item label="Balance">{creditorBalance}</Form.Item>
          </Col>
        )} */}
        <Col span={8}>
          <Form.Item
            name="clientId"
            label="Client"
            rules={[{ required: true, message: "Client is required." }]}
          >
            <Select
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {getDebtors(account).map((option) => (
                <Select.Option key={option.id} value={option.id}>
                  {option.accountName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="billForId"
            label="Bill For"
            rules={[{ required: true, message: "Bill For is required." }]}
          >
            <Select
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {getDebtors(account).map((option) => (
                <Select.Option key={option.id} value={option.id}>
                  {option.accountName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="language"
            label="Language"
            rules={[
              {
                max: 50,
                message: "Language should be maximum of 50 characters.",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        {isClassified !== 1 && (
          <>
            <Col span={8}>
              <Form.Item
                name="material"
                label="Material"
                rules={[
                  {
                    max: 100,
                    message: "Material should be maximum of 100 characters.",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="file"
                label="File"
                rules={[
                  {
                    max: 100,
                    message: "file should be maximum of 100 characters.",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={2}>
              <Form.Item
                name="width"
                label="Width"
                rules={[{ required: true, message: "Width is required." }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={2}>cms</Col>
            <Col span={2}>
              <Form.Item
                name="height"
                label="Height"
                rules={[{ required: true, message: "Height is required." }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={2}>cms</Col>{" "}
          </>
        )}
        <Col span={8}>
          <Form.Item
            name="rate"
            label="Rate"
            rules={[{ required: true, message: "Rate is required." }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="captionId" label="Caption">
            <Select
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {caption.map((option) => (
                <Select.Option key={option.id} value={option.id}>
                  {option.captionName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="specialInstruction"
            label="Special Instruction"
            rules={[
              {
                max: 500,
                message:
                  "Special Instruction should be maximum of 500 characters.",
              },
            ]}
          >
            <TextArea showCount maxLength={500} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="isBillDone" label="Bill Done">
            <Select
              defaultValue={false}
              options={[
                {
                  value: false,
                  label: "No",
                },
                {
                  value: true,
                  label: "Yes",
                },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="dateOfInsertion" label="Date Of Insertion">
            <DatePicker format={DEFAULT_DATE_FORMAT} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label=" ">
            {isSingle === false && (
              <Button title="Add" onClick={addDateInTag}>
                Add
              </Button>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="scheme" label="Scheme">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      {multipleDates.length > 0 && (
        <Row>
          <Col span={24}>
            {multipleDates?.map((date) => {
              return getTag(date);
            })}
          </Col>
        </Row>
      )}
      {isClassified !== 1 && (
        <Row>
          <Col span={8}>
            <Form.Item
              name="advancePayment"
              label="Advance Payment"
              valuePropName="checked"
            >
              <Switch onChange={advancePaymentSwitchChanged} />
            </Form.Item>
          </Col>
        </Row>
      )}
      {advancePaymentFields}
    </Form>
  );
  return isViewModal ? (
    <Modal
      title={
        isClassified === 1 ? "Release Order - Classified" : "Release Order"
      }
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      okText="Save"
      cancelText={isViewOnly ? "Close" : "Cancel"}
      okButtonProps={{
        disabled: isViewOnly ? true : false,
        loading: loadingSaveButton,
      }}
    >
      {formComp}
      {selectedRecord && isViewOnly && (
        <Row justify="space-between">
          <Button type="primary" onClick={previousButtonClicked}>
            <LeftOutlined />
            Previous
          </Button>
          <Button type="primary" onClick={nextButtonClicked}>
            Next
            <RightOutlined />
          </Button>
        </Row>
      )}
    </Modal>
  ) : (
    <>{formComp}</>
  );
}

export default AddReleaseOrder;
